module.exports = __webpack_public_path__ + "img/injuryReport.ac34ffd1.svg";